import type { StoryScript } from '../types';

/** Sommerhistorie med navn, to ting og automatisk han/hun. */
export const SOMMER_I_HAVEN: StoryScript = {
  id: 'sommer-i-haven',
  title: 'Sommer i haven',
  storyLevel: 1,
  defaultBlankLength: 12,
  blanks: {
    navn: {
      maxLength: 10,
      hint: 'fx ida eller mads',
    },
    ting1: {
      maxLength: 14,
      hint: 'fx bog, bold eller kaffekop',
      definiteOnReuse: true,
    },
    ting2: {
      maxLength: 14,
      hint: 'fx æbler, cykel eller post',
    },
  },
  beats: [
    {
      id: 'b1',
      template:
        'det var sommer og {{navn:10}} sad i sin have og kiggede på {{art:ting1}} {{ting1:14}}',
    },
    { id: 'b2', template: 'så hørte {{pron:navn}} en stemme bag sig' },
    {
      id: 'b3',
      template: '{{navn}} vil du ikke hjælpe mig med {{ting2:14}}',
    },
    {
      id: 'b4',
      template:
        '{{navn}} lagde {{ting1}} fra sig og gik hen og hjalp med {{ting2}}',
    },
  ],
};
